import React from 'react'
import SelectInput from '../Common/SelectInput'

function Form({ onClearHandler, emailHandler, formSubmitHandler, onChangeHandler, formObj, badges }) {
  const { state, selectedBadge, userEmail } = formObj

  return (
    <form action='' onSubmit={formSubmitHandler}>
      <div className='row ps-2 ps-md-2 pt-4'>
        <div className='col-md-4 mt-4'>
          <SelectInput
            name='selectedBadge'
            state={selectedBadge}
            formState={state}
            onChangeHandler={onChangeHandler}
            labelText='Badge'
            placeholder='Select the badge'
            options={badges.filter((element) => element.status === 'available')}
            screen={'issue'}
          />
        </div>
        <div className='col-md-4 mt-1'>
          <label htmlFor='email' className='form-label'>
            Email id
          </label>
          <input
            type='email'
            className={`form-control py-2 ${userEmail.status}`}
            id='email'
            name='email'
            value={userEmail.value}
            onChange={emailHandler}
            placeholder='example@xebia.com'
            required={true}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-4 d-flex justify-content-start mt-3 ps-4 ps-md-2 mb-2'>
          <button className='btn btn-light px-4 py-2 my-4 me-3' onClick={onClearHandler}>
            Clear
          </button>
          <button
            className={`btn btn-${state === 'submitted' ? 'success' : 'badge'} px-4 py-2 my-4`}
            disabled={state !== 'idle'}
            type='submit'>
            {state === 'submitting' && <div id='loading'></div>}
            {state === 'idle' && (
              <span>
                <i className='far fa-check-circle me-2'></i>Issue Badge
              </span>
            )}
            {state === 'submitted' && 'Access Request Created Successfully'}
          </button>
        </div>
      </div>
    </form>
  )
}

export default Form
